<template functional>
  <div class="DialogBox">
    <p v-if="props.title ? true : false" class="topMsg">{{props.title}}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:''
        }
    }
};
</script>

<style scoped lang="scss">
.DialogBox {
  background: #fff;
  width: 950px;
  border-radius: 15px;
  padding: 40px;
  box-sizing: border-box;
  .topMsg {
    text-align: center;
    font-size: 40px;
    color: #000;
    margin-bottom: 60px;
  }
  
}
</style>
